<template>
    <div>
        <router-view></router-view>
        <!--<v-tabs color="primary" dark icons-and-text class="fixed-bottom" grow>-->
            <!--<v-tabs-slider color="white"></v-tabs-slider>-->

            <!--<v-tab to="/product/list" exact>-->
                <!--知识库-->
                <!--<v-icon>school</v-icon>-->
            <!--</v-tab>-->

            <!--<v-tab to="/product/my" exact>-->
                <!--我的-->
                <!--<v-icon>face</v-icon>-->
            <!--</v-tab>-->
        <!--</v-tabs>-->
    </div>

</template>

<script>

    export default {
        data() {
            return {}
        },
        mounted() {

        },
        computed: {},
        methods: {}
    }
</script>

<style lang="scss">
.fixed-bottom {
        position: fixed !important;
        bottom: 0;
        width: 100%;
    }
</style>
